import {AutoComplete, Button, Card, DatePicker, Form, Input, Modal, Select, Spin, Table, Timeline} from 'antd';
import React from "react";
import {getFormFieldByTypeForTpwModule, sanitizeFieldName} from "../../util/methods";
import SubListTpw from "../../components/SubListTpw";
import DocumentList from "../../components/DocumentList";
import * as moment from "moment";

const { TextArea } = Input;

class Create extends React.Component {
  state = {
    comments : '',
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    this.props && this.props.form && this.props.form.resetFields();
  }

  fetchQuotations = (values) => {
    this.props.fetchQuotations(values);
  }

  componentWillUnmount() {
    this.props.clearProps();
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();
    if(this.props.id && this.props.id !== undefined && this.props.id !== null && this.props.id !=='') {
      this.props.form.setFieldsValue({quotations: this.props.id})
    }
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      this.props.changeChecked();
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
        this.props && this.props.form && this.props.form.resetFields();
      }
    });
    this.props.form.setFieldsValue({tpwNo : ''});
  };

  addComments = (e) => {
    this.setState({comments: e.target.value})
  }

  handleModalCancel = e => {
   this.props.handleModalCancel();
  };

  handleCancel = (comments, date) => {
    let data = {
      quote : this.props && this.props.quote,
      comments: comments,
      dateOfCancellation: date,
      dateOfCompletion: '',
    }

    this.props.form.setFieldsValue({quotations: this.props.quote});

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      } else {
        this.props.form.setFieldsValue({tpwNo: ''});
        this.props.cancelTpw(data);
      }
    });
  }

  workDone = (comments, date) => {
    let data = {
      quote : this.props && this.props.quote,
      comments: comments,
      dateOfCompletion : date,
      dateOfCancellation: '',
    }
    this.props.form.setFieldsValue({quotations: this.props.quote});

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      } else {
        this.props.form.setFieldsValue({tpwNo: ''});
        this.props.workDone(data);
      }
    });
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {loading, filters, title, resource, tpw, form, quotations, columns, pagination, size, handleChange, visible, quoteData, quoteFilters} = this.props;
    return (
      <div style={{width: '100%'}}>
        <Modal width = {1000}
               style={{ top: 20 }}
               title={`View Quotation`}
               onCancel={this.handleModalCancel}
               footer={null}
               visible={visible}
               centered
          > <Spin spinning={this.props.loading}>
        <Card className={`gx-card-metrics`} title={'View Quote'}>
          <Form layout="vertical">
            {
              Object.keys(this.props && this.props.quoteFilters).map((item) => {
                if (item === 'tpwNo') {
                  return <Form.Item key={'tpwSearchQuery'} label={'Search Tpw'}>
                    { this.props && this.props.form && this.props.form.getFieldDecorator(item, {
                      rules: [{
                        required: true,
                        message: `tpw is required!`
                      }],
                      initialValue: (quoteData && quoteData.tpwNo) ? quoteData.tpwNo : '',
                    })(
                      <AutoComplete
                        placeholder={'ex. tpw'}
                        disabled={true}>
                      </AutoComplete>
                    )}
                  </Form.Item>
                }
                else if(quoteFilters && quoteFilters[item].type === 'Array' && quoteFilters[item].schema) {
                  return <div key={ quoteFilters[item] && quoteFilters[item].field ? quoteFilters[item].field : quoteFilters[item] }>
                    {
                      quoteFilters[item] && quoteFilters[item].field ? sanitizeFieldName(quoteFilters[item].field) : ''}
                    <SubListTpw key={item} item={quoteFilters[item]} form={this.props.form} data={quoteData[item]} title={'EDIT'} resource={'ThirdPartyWorkQuotation'} disableAll={true}/>
                  </div>
                }
              })}
            <div key = {'formItems'}>
              {
                Object.keys(quoteFilters).map((item) => {
                  if(item ==='date' || item ==='vendor' || item === 'targetDateOfCompletion' || item === 'totalCost') {
                    return getFormFieldByTypeForTpwModule(quoteFilters, item, this.props && this.props.form && this.props.form.getFieldDecorator, quoteData, {resource : this.props && this.props.resource, title : 'EDIT', disableMaster: true});
                  }

                  // Document Upload Form
                  else if (quoteFilters[item].type === 'Array' && quoteFilters[item].options.ref) {
                    return <DocumentList match={this.props && this.props.match} history={this.props && this.props.history}
                                         key={item} item={quoteFilters[item]} form={this.props && this.props.form} data={quoteData[item]}
                                         resource={this.props && this.props.resource} title={'EDIT'} hideRemove={true} hideEdit = {true}
                                          disableAdd = {true}/>
                  }
                })}
            </div>
            {
              this.props && this.props.title && this.props.title === 'EDIT' ?
                <Form.Item key={'status'} label={'Status'}>
                  <Select style = {{width: '190px'}} showArrow={false} disabled={true} value={(quoteData && quoteData.status) ? quoteData.status : ''} />
                </Form.Item> : ''
            }
          </Form>
        </Card>
      </Spin>
    </Modal>
        <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Form.Item key={'tpwSearchQuery'} label={'Search Tpw'}>
              { getFieldDecorator('tpwNo', {
                rules: [{
                  required: true,
                  message: `tpw is required!`
                }],
              })(
                <AutoComplete
                  showSearch={true}
                  allowClear={true}
                  placeholder={'ex. tpw'}
                  onSearch={this.props.fetchTpwNo}
                  onSelect={this.fetchQuotations}>
                  {
                    tpw && tpw.data && tpw.data.map((item) => {
                      return <Select.Option key={item._id} value={item['tpwNo']}>{item['tpwNo']}</Select.Option>
                    })
                  }
                </AutoComplete>
              )}
            </Form.Item>

            <Form.Item key={'quotations'} label= {'Quotations'}>
              { getFieldDecorator('quotations', {
                rules: [{
                  required: true,
                  message: `Quotations is required!`
                }],
              })(<Table style = {{overflow: "auto"}} columns = { columns && columns.length ? columns : [] }
                        dataSource = { quotations && quotations.length ? quotations : [] } size = {size} rowKey = {'_id'} loading = {loading} />
                )
              }
            </Form.Item>
            <Timeline>
              {
                this.props && this.props.historyData ? this.props && this.props.historyData &&
                  this.props.historyData.map(item => {
                    return <Timeline.Item key = {item && item._id}> Quote of a Vendor <b> {item && item.vendor} </b> against a Tpw - <b>{this.props && this.props.tpwNo}</b> was
                      <b> {item && item.tpwStatus} </b> on
                      {
                        item && item.tpwStatus === 'Approved' ? <b> {
                      moment(item.approvalDate || '').format('DD-MM-YYYY hh:mm a') } </b> :
                      item && item.tpwStatus === 'Cancelled' ? <b>{
                        moment(item.dateOfCancellation || '').format('DD-MM-YYYY hh:mm a') } </b>: '' }
                    </Timeline.Item>
                  }) : ''
              }
            </Timeline>
            {
              this.props && !this.props.disable?
                <Form.Item key={'approvalDate'} label={'Approval Date'}>
                  {getFieldDecorator('approvalDate', {
                    rules: [{
                      required: true,
                      message: `approvalDate is required!`
                    }],
                  })(<DatePicker />)
                  }
                </Form.Item> :<Form.Item key={'date'} label={'Date'}>
                  {getFieldDecorator('date', {
                    rules: [{
                      required: true,
                      message: `Date is required!`
                    }],
                  })(<DatePicker />)
                  }
                </Form.Item>
            }

            {
              this.props && !this.props.disable ?
                <Form.Item>
                  <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>Submit</Button>
                </Form.Item> : ''
            }
            {
              this.props && this.props.disable ?
                <Form.Item key={'comments'} label={'Comments'}>
                  {getFieldDecorator('comments', {})(<TextArea onChange={this.addComments} rows={4}/>)}
                </Form.Item> : ''
            }

                <div style = {{display:'flex', flexDirection:'row'}}>
                  {
                    this.props && this.props.disable ?
                      <Form.Item>
                        <Button onClick={(com) => {this.workDone(this.state.comments, this.props.form.getFieldValue('date'))}}
                                style={{marginLeft: '10px', color: 'white', backgroundColor: "blue"}}
                                loading={loading}>Work Done</Button>
                      </Form.Item> : ''
                  }
                  {
                    this.props && this.props.disable ?
                      <Form.Item>
                        <Button onClick={(com) => {this.handleCancel(this.state.comments, this.props.form.getFieldValue('date'))}}
                                style={{marginLeft: '10px', color: 'white', backgroundColor: "red"}}
                                loading={loading}>Cancel</Button>
                      </Form.Item> : ''
                  }
                </div>
          </Form>
        </Card>
      </Spin>
      </div>);
  }
}
const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;


